import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
export function MoreTestimonials() {
  const testimonials = [{
    quote: 'Compré un domingo a la noche. El lunes entré al campo con el plan exacto de la sesión. Las sesiones del Tomo 1 son exactamente lo que necesitaba para arrancar la pretemporada. Nunca más improviso.',
    name: 'Sofía M.',
    location: 'Buenos Aires',
    role: 'Entrenadora en Club Barrial'
  }, {
    quote: 'El Tomo de Preparación Física me cambió todo. Mis jugadoras mejoraron visiblemente en un mes. Y el protocolo anti-lesiones me da la tranquilidad que antes no tenía en ningún entrenamiento.',
    name: 'Carolina R.',
    location: 'Rosario',
    role: 'DT de Fútbol Femenino Juvenil'
  }, {
    quote: 'El sistema de táctica del Tomo 4 es único en el mercado. Situaciones tácticas con diagramas listos para trabajar. Antes tardaba horas armando una sesión táctica. Ahora abro el PDF y en 5 minutos tengo todo listo.',
    name: 'Valentina F.',
    location: 'Córdoba',
    role: 'Entrenadora de Fútbol Femenino Grupal e Individual'
  }, {
    quote: 'La tasa de abandono de mis jugadoras bajó muchísimo. Sin cambiar lo que enseño. Solo aplicando el sistema de progresión mensual y la variedad de los 6 tomos. Las chicas ahora quieren venir porque siempre hay algo nuevo.',
    name: 'Luciana P.',
    location: 'Tucumán',
    role: 'Entrenadora en Liga Regional Femenina'
  }, {
    quote: 'El Tomo 6 de liderazgo me cambió la cabeza. Nunca había dimensionado la importancia del lado humano en un plantel femenino. Ahora gestiono el vestuario con una confianza que antes no tenía.',
    name: 'Marcela G.',
    location: 'Mendoza',
    role: 'DT de Categorías Formativas Femeninas'
  }, {
    quote: 'El Megapack Porteras del Pack Completo me sorprendió. Nunca encontré material específico para entrenar arqueras en fútbol femenino. Ahora tengo sesiones listas y mi portera mejoró exponencialmente.',
    name: 'Laura V.',
    location: 'Santa Fe',
    role: 'Entrenadora con enfoque en Arqueras'
  }, {
    quote: 'La Academia del Entrenador me hizo ver que me faltaba el lado profesional y de gestión. Los diagramas, las fichas y los modelos de contrato me cambiaron la forma de presentarme ante los clubes.',
    name: 'Ana R.',
    location: 'Salta',
    role: 'DT Independiente de Fútbol Femenino'
  }];
  return <section className="py-10 md:py-20 px-4 bg-navy text-white overflow-hidden" data-id="element-204">
      <div className="max-w-6xl mx-auto" data-id="element-205">
        <div className="text-center mb-8 md:mb-16" data-id="element-206">
          <h2 className="text-3xl md:text-5xl font-black mb-3 md:mb-4" data-id="element-207">
            Lo que dicen los entrenadores que ya lo usan:
          </h2>
          <p className="text-lg md:text-xl text-brandGreen font-bold" data-id="element-208">
            +300 entrenadores de fútbol femenino de todo el país ya tienen su
            FÚTBOL FEMENINO RESUELTO
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-id="element-209">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className={`bg-navy-light p-6 md:p-8 rounded-3xl border border-white/10 flex flex-col relative ${index === 6 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-210">
              <Quote className="absolute top-4 right-4 md:top-6 md:right-6 w-8 h-8 md:w-12 md:h-12 text-white/5" data-id="element-211" />
              <div className="flex gap-1 mb-4 md:mb-6" data-id="element-212">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 md:w-5 md:h-5 fill-brandGreen text-brandGreen" data-id="element-213" />)}
              </div>
              <p className="text-gray-300 italic mb-6 md:mb-8 flex-grow text-base md:text-lg relative z-10 leading-relaxed" data-id="element-214">
                "{testimonial.quote}"
              </p>
              <div className="mt-auto border-t border-white/10 pt-4 md:pt-6" data-id="element-215">
                <p className="font-bold text-white text-base md:text-lg" data-id="element-216">
                  {testimonial.name}
                </p>
                <p className="text-brandGreen font-semibold text-xs md:text-sm mb-1" data-id="element-217">
                  {testimonial.location}
                </p>
                <p className="text-gray-400 text-xs md:text-sm" data-id="element-218">
                  {testimonial.role}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}